import { useEffect } from 'react';

export default function useEscapeKey(active, onEscape) {
  useEffect(() => {
    if (!active) return;
    function onKeyDown(e) {
      if (e.key === 'Escape') onEscape();
    }
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [active, onEscape]);
}

